import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `CopiaSeguridad/eliminarCopiaSeguridadSeleccion`, method: 'POST', body: {list}, token: token})
}
